export default __webpack_public_path__ + "static/media/img_20.6a023379.JPG";